import apiFilesClient from '@/services/apiFilesClient';

import errorHandler from '@/utilities/serverErrorHandler';

export const files = {
  namespaced: true,
  state: {
    files: {
      ua_icexpressionofinterest: [],
      ua_icapplication: []
    }

  },
  getters: {
    getAllFiles: state => (applicationType) => {
      return state.files[applicationType];
    },
    getFilesByType: state => (applicationType, itemType) => {
      const files = state.files[applicationType].filter(item => item.subject === itemType);

      return files;
    }
  },
  mutations: {
    UPDATE (state, payload) {
      const files = state.files[payload.applicationType];
      state.files[payload.applicationType] = [...files, ...payload.files];
    },
    CREATE (state, payload) {
      state.files[payload.applicationType] = payload.files;
    }
  },
  actions: {
    uploadToSharepoint ({ commit, dispatch, rootGetters }, payload) {
      dispatch('ui/updateInterstitial', { isLoading: true, message: 'Uploading your supporting files...' }, { root: true });
      return apiAuthClient.post('SaveNewDocumentToSharepoint', JSON.stringify(payload), rootGetters['auth/getAccessToken']).then((res) => {
        if (res.status === 200 && res.data) {
          commit('UPDATE', { applicationType: 'ua_icclaim', files: [payload] });

          return true;
         }
      }).catch(err => {
        return errorHandler('notesErrors', err);
      }).finally(() => {
        dispatch('ui/updateInterstitial', { isLoading: false, message: '' }, { root: true });
      });
    },
    uploadNewFiles ({ commit, dispatch, rootGetters }, payload) {
      dispatch('ui/updateInterstitial', { isLoading: true, message: 'Uploading your supporting files...' }, { root: true });

      let folderAppPath = "";
      if (payload.applicationTypeID === "Eoi") {
          folderAppPath = "1. " + payload.applicationTypeID;
      } else if (payload.applicationTypeID === "Claims") {
          folderAppPath = "6. " + payload.applicationTypeID;
      } else if (payload.applicationTypeID === "Application") {
          folderAppPath = "2. " + payload.applicationTypeID;
      }

      // This name path is to use sharepoint folder name if it's an EOI or Application 
      let namePath = (payload.applicationTypeID === "Eoi" || payload.applicationTypeID === "Application") ? payload.sharepointFolderName : "";

      return apiFilesClient.post(`project/${process.env.VUE_APP_API_PROJECT_FOLDER_ID}/bulk/folder-path/${namePath}/${folderAppPath}/${payload.itemType}`, payload.data, rootGetters['auth/getAccessToken']).then((res) => {
        if (res.status === 201 && res.data) {
            const fileList = res.data.files || res.data.items || []; // check actual key
            const items = fileList.map(item => ({
              filename: item.fileName,
              subject: payload.itemType
            }));

            commit('UPDATE', { applicationType: payload.applicationType, files: items });
            return true;
          } else {
            // ✅ Ensure a fallback return if status !== 200 or data missing
            return {
                type: 'error',
                message: 'An unexpected error occurred while uploading files.'
            };
        }
      }).catch(err => {
        if (err.response) {
          return errorHandler('notesErrors', err);
        }
      return { message: 'The files you are trying to upload exceed the maximum file size of 10MB. Please try reducing the file size before uploading', type: 'error' };
      }).finally(() => {
        dispatch('ui/updateInterstitial', { isLoading: false, message: '' }, { root: true });
      });
    },
    loadFiles ({ commit, dispatch, rootGetters }, payload) {
      dispatch('ui/updateInterstitial', { isLoading: true, message: 'Getting your uploaded files...' }, { root: true });
      return apiFilesClient.get(`project/${process.env.VUE_APP_API_PROJECT_FOLDER_ID}/metadata`, rootGetters['auth/getAccessToken']).then((res) => {
        if (res.status === 200 && res.data) {
          const items = [];
          res.data.forEach((item) => {
            const pathApp = item.relativePath.split('/');

            // This is to make sure the application type and path of sharepoint is the same for the if statement below.
            let apptype = "";
            if (payload.applicationType === "eoi") {
                apptype = '1. expression of interest'
            } else if (payload.applicationType === "application") {
                apptype = '2. application'
            }

            if(apptype == pathApp[1]) {
              const itemData = {
                "annotationid": item.fileId,
                "createdby": item.fileId,
                "documentbody": item.downloadUri,
                "filename": item.fileName,
                "mimeType": item.mimeType,
                "modifiedby": item.fileId,
                "notetext": null,
                "objecttypecode": payload.applicationType,
                "overriddencreatedon": null,
                "ownerid": item.fileId,
                "subject": pathApp[2].toUpperCase()
              };
              items.push(itemData);
            }
          });
          commit('CREATE', { applicationType: payload.applicationTypeId, files: items });
          return true;
        }
      }).catch(err => {
          return errorHandler('notesErrors', err);
      }).finally(() => {
        dispatch('ui/updateInterstitial', { isLoading: false, message: '' }, { root: true });
      });
    }
  }

};
